const prefix = 'active-versions-page';

export const i18n = {
    product: {
        id: `${prefix}.product`,
        defaultMessage: 'Product',
    },
    version: {
        id: `${prefix}.version`,
        defaultMessage: 'Version',
    },
    total: {
        id: `${prefix}.total`,
        defaultMessage: 'Total',
    },
    latestSignIn: {
        id: `${prefix}.latestSignIn`,
        defaultMessage: 'Latest Sign-In',
    },
    noVersionsTitle: {
        id: `${prefix}.noVersionsTitle`,
        defaultMessage: 'No active versions',
    },
    noVersionsMessage: {
        id: `${prefix}.noVersionsMessage`,
        defaultMessage: 'There are no active versions to display.',
    },
    noVersion: {
        id: `${prefix}.noVersion`,
        defaultMessage: '(No version)',
    },
    lastNDays: {
        id: `${prefix}.lastNDays`,
        defaultMessage: 'Last {n} days',
    },
    allTime: {
        id: `${prefix}.allTime`,
        defaultMessage: 'All time',
    },
} as const;
